import { Component, OnInit } from '@angular/core';
import { Entity } from '../select-list/select-list.component';
import { ApiService } from '../../api.service';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-hospitalizations',
  templateUrl: './hospitalizations.component.html',
  styleUrls: ['./hospitalizations.component.css']
})
export class HospitalizationsComponent implements OnInit {
  private _selectedItems: Entity[];
  items: any;

  constructor(private api: ApiService) {
    this.selectedItems = [];
    console.log('ctor');
  }

  ngOnInit() {
    console.log('init');
    console.log(this.api.session);
    this.items = this.api.session.hospitalizations.map(x => new Entity(x.name, x));
  }

  get selectedItems(): Entity[] {
    return this._selectedItems;
  }
  set selectedItems(value) {
    MyUtility.scrubChildren(value);
    this._selectedItems = value;
    this.api.session.currentCriteria.hospitalizations.selectedItems = value.map(x => x.item);
  }
}
